
import React from 'react';

const Martinjt_ocb_config_builder_GitHubRepository  = () => {
  return (
    <div>

<div className="a row pr-2" style={{ padding: '.75em 1em' }}>
    <div className="col-sm-12">
        <div className="col-sm-12 col-lg-4 mt-6">
            <div className="rob-conery-card card shadow h-100" style={{ border: '2px solid black', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' 
             // Add shadow here 
             }}>
                <div className="Box d-flex p-3 width-full public source">
                    <div className="pinned-item-list-item-content">
                        <div className="d-flex width-full position-relative">
                            <div className="flex-1">
                                <svg
                                    aria-hidden="true"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    version="1.1"
                                    width="16"
                                    data-view-component="true"
                                    className="octicon octicon-repo mr-1 color-fg-muted"
                                >
                                    <path d="M2 2.5A2.5 2.5 0 0 1 4.5 0h8.75a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2h-8a1 1 0 0 0-.714 1.7.75.75 0 1 1-1.072 1.05A2.495 2.495 0 0 1 2 11.5Zm10.5-1h-8a1 1 0 0 0-1 1v6.708A2.486 2.486 0 0 1 4.5 9h8ZM5 12.25a.25.25 0 0 1 .25-.25h3.5a.25.25 0 0 1 .25.25v3.25a.25.25 0 0 1-.4.2l-1.45-1.087a.249.249 0 0 0-.3 0L5.4 15.7a.25.25 0 0 1-.4-.2Z"></path>
                                </svg>
                                <span data-view-component="true" className="position-relative">
                                    <a
                                        href="https://github.com/martinjt/ocb-config-builder"
                                        className="Link mr-1 text-bold wb-break-word"
                                        aria-labelledby="tooltip-6baf9a22-427b-4407-9260-e2fbc25d7c37"
                                        style={{ textDecoration: 'underline' }} // Example of underlined link
                                    >
                                        <span className="repo">ocb-config-builder                                        </span>
                                    </a>
                                    <span></span>
                                    <span className="Label Label--attention v-align-middle mt-1 no-wrap v-align-baseline Label--inline">
                                        Public 
                                    </span>
                                </span>

                             
                             <p><a href="https://martinjt.me/2023/12/20/building-a-secure-opentelemetry-collector/">Building a secure OpenTelemetry Collector December 20, 2023</a></p>

                                <p className="mb-0 mt-2 f6 color-fg-muted">
                                    <a href="https://github.com/martinjt/ocb-config-builder?tab=readme-ov-file" className="pinned-item-meta Link--muted">
                                        <svg
                                            aria-label="stars"
                                            role="img"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            version="1.1"
                                            width="16"
                                            data-view-component="true"
                                            className="octicon octicon-star"
                                        >
                                            <path d="M8 .25a.75.75 0 0 1 .673.418l1.882 3.815 4.21.612a.75.75 0 0 1 .416 1.279l-3.046 2.97.719 4.192a.751.751 0 0 1-1.088.791L8 12.347l-3.766 1.98a.75.75 0 0 1-1.088-.79l.72-4.194L.818 6.374a.75.75 0 0 1 .416-1.28l4.21-.611L7.327.668A.75.75 0 0 1 8 .25Zm0 2.445L6.615 5.5a.75.75 0 0 1-.564.41l-3.097.45 2.24 2.184a.75.75 0 0 1 .216.664l-.528 3.084 2.769-1.456a.75.75 0 0 1 .698 0l2.77 1.456-.53-3.084a.75.75 0 0 1 .216-.664l2.24-2.183-3.096-.45a.75.75 0 0 1-.564-.41L8 2.694Z"></path>
                                        </svg>
                                        13
                                    </a>
                                    <a href="https://github.com/martinjt/ocb-config-builder?tab=readme-ov-file/forks" className="pinned-item-meta Link--muted">
                                        <svg
                                            aria-label="forks"
                                            role="img"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            version="1.1"
                                            width="16"
                                            data-view-component="true"
                                            className="octicon octicon-repo-forked"
                                        >
                                            <path d="M5 5.372v.878c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75v-.878a2.25 2.25 0 1 1 1.5 0v.878a2.25 2.25 0 0 1-2.25 2.25h-1.5v2.128a2.251 2.251 0 1 1-1.5 0V8.5h-1.5A2.25 2.25 0 0 1 3.5 6.25v-.878a2.25 2.25 0 1 1 1.5 0ZM5 3.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm6.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-3 8.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"></path>
                                        </svg>
                                        1
                                    </a>
                                </p>

                                <p dir="auto">C#</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


</div>

);
};

export default Martinjt_ocb_config_builder_GitHubRepository;
